import React from "react";
import { Navigate } from "react-router-dom";
import Main from "./layout/Main";

const CommanRoute = ({ children }) => {
  return (
    <>
      <Main>
        {children}
      </Main>
    </>
  )

};

export default CommanRoute;
